export const initValidator = (Validator) => {
  // 判断大咖账号是否至少6位数字
  Validator.extend('code', {
    getMessage: field => field + '至少是6位数字',
    validate: value => {
      return /^(\d{6,})$/.test(value)
    }
  })
  // 判断密码是否是6-16位字符
  Validator.extend('password', {
    getMessage: field => 'The password should be 6-16 characters combination',
    validate: value => {
      return /^([0-9A-Za-z]{6,16})$/.test(value)
    }
  })
  // 数字验证
  Validator.extend('oldPasswd', {
    getMessage: field => 'New password does not match old password',
    validate: (value, args) => {
      if (value) {
        return value === args[0]
      }
      return false
    }
  })
}